import React from "react";
import "./style.css"; // Custom CSS for styling
import DataTable from "react-data-table-component";

const RowDataTableModal = ({ isOpen, closeModal, data, title, type }) => {
  console.log("YTRE06", data);

  let columns = [
    { name: "Sln", selector: (row, index) => index + 1, sortable: true },
    { name: "Name", selector: (row) => row?.name, wrap: true },
    { name: "Email", selector: (row) => row?.email, wrap: true },
    { name: "Phone", selector: (row) => row?.phoneNo, wrap: true },
  ];

  if (type === "localities") {
    columns = [
      { name: "Sln", selector: (row, index) => index + 1, sortable: true },
      { name: "Name", selector: (row) => row?.name, wrap: true },
    ];
  }

  return (
    <>
      {isOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <span className="close-icon" onClick={() => closeModal(false)}>
              &times;
            </span>
            <h2>{title}</h2>
            <DataTable
              columns={columns}
              data={data}
              pagination={true}
              responsive={true}
              highlightOnHover={true}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              fixedHeader={true} // Add this
              fixedHeaderScrollHeight="500px" // Add this - adjust as needed
            />
            <button className="close-btn" onClick={() => closeModal(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default RowDataTableModal;
